import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useRef } from 'react'

import { useMapsInstanceContext } from '../../../hooks/useMapsInstanceContext'
import { useMapsUtilityContext } from '../../../hooks/useMapsUtilityContext'
import MarkLocationToolHelpPopup from './MarkLocationToolHelpPopup'
import * as Styles from './styles'

const ViewEditToggleTool = (): React.ReactElement => {
   const { isEditMode, setIsEditMode } = useMapsInstanceContext()
   const { mapsT } = useMapsUtilityContext()

   const helpPopupTriggerRef = useRef<HTMLDivElement>(null)

   const renderLabelText = (text: string, isActive: boolean) => (
      <p
         className={cn(
            'text-sm-medium',
            isActive ? 'text-gray-700' : 'text-gray-500'
         )}
      >
         {text}
      </p>
   )

   return (
      <div className={Styles.toggleContainer}>
         <div
            className={cn(Styles.toggleItem, {
               [Styles.activeToggleItem]: !isEditMode
            })}
            onClick={() => setIsEditMode(false)}
         >
            {renderLabelText(mapsT('mode.viewMode'), !isEditMode)}
         </div>

         <div
            className={cn(Styles.toggleItem, {
               [Styles.activeToggleItem]: isEditMode
            })}
            onClick={() => setIsEditMode(true)}
            ref={helpPopupTriggerRef}
         >
            {renderLabelText(mapsT('mode.editMode'), isEditMode)}
         </div>

         <MarkLocationToolHelpPopup triggerRef={helpPopupTriggerRef} />
      </div>
   )
}

export default observer(ViewEditToggleTool)
